import React from 'react';

import RetinaImage from 'react-retina-image';
import close from '../images/icon-close.png';
import close2x from '../images/icon-close@2x.png';

import './BotaoFechar.css';

const BotaoFechar = ({ onClick }) => (
  <a onClick={ () => onClick() }>
    <RetinaImage className="close-btn" src={[close, close2x]} />
  </a>
);

export default BotaoFechar;



// WEBPACK FOOTER //
// ./src/components/BotaoFechar.js